<template>
    <MainContentSearchable title="Listado de códigos QR" id="codigos" v-model="filters" :meta="loading ? {} : codigos.meta" @updated="getCodigos">
        <template v-slot:header>
            <div class="ml-auto">
                <div class="mb-3">
                    <Button class="mr-2" @click="exportarCodigos()">Exportar códigos</Button>
                    <Button @click="showModal('crear-codigos')">Generar códigos</Button>
                </div>
                <GenerarCodigos @close="closeModal" />
                <AvisoCodigosExportados />
            </div>
        </template>
        <template v-slot:extra-options>
            <div class="col-12 col-lg-3">
                <div class="my-3">
                    <b-form-select 
                        v-model="filters.used"
                        :options="[
                            { value: null, text: 'Ambos' },
                            { value: 1, text: 'Usados' },
                            { value: 0, text: 'No usados' }
                        ]"
                        class="mb-3" 
                        @change="getCodigos" 
                    />
                </div>
            </div>
        </template>
        <template v-slot:content>
            <div v-if="codigos.data" :class="['table', { 'expanded': codigos.data.length <= 3 }]">
                <b-table hover :items="codigos.data" :fields="fields" id="codigos-table">
                    <template #cell(used)="{ item }">
                        <span v-if="item.used" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                        <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                    </template>
                    <template #cell(opciones)="{ item, index }">
                        <OpcionesDropdownTableComponent 
                            :lastIndex="codigos.data.length > 3 && index >= codigos.data.length - 3"
                            v-bind:options="[
                                { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'}
                            ]"
                        />
                        <BorrarCodigo :codigo="item" @close="closeModal" @terminado="getCodigos" />
                    </template>
                </b-table>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import GenerarCodigos from '@/components/backend/eventos/sesiones/codigos-qr/modals/GenerarCodigos';
    import BorrarCodigo from '@/components/backend/eventos/sesiones/codigos-qr/modals/BorrarCodigo';
    import AvisoCodigosExportados from '@/components/backend/eventos/sesiones/codigos-qr/modals/AvisoCodigosExportados';

    export default {
        props: {
            evento_id: [Number, String],
            sesion_id: [Number, String]
        },
        data() {
            return {
                codigos: {},
                loading: false,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    used: null,
                },
                fields: [
                    { key: "codigo", label: "Código", class: 'text-center' },
                    { key: "used", label: "Usado", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ]
            }
        },
        methods: {
            getCodigos() {
                this.loading = true;
                this.filters.qr_code = this.filters.search;
                let params = {
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    filters: this.filters
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.codigos-qr'), params).then(res => {
                    this.codigos = res.data;
                }).finally(() => this.loading = false);
            },
            exportarCodigos() {
                this.loading = true;

                let params = {
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    filters: {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.codigos-qr.exportar'), params).then(res => {
                    this.showModal('exportar-codigos');
                }).finally(() => this.loading = false);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, actualizar) {
                this.$modal.hide(modal);

                if(actualizar) {
                    this.getCodigos();
                }
            },
        },
        created() {
            this.getCodigos();
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, GenerarCodigos, BorrarCodigo, AvisoCodigosExportados
        }
    }
</script>